define('CopyrightDate', ['CopyrightDate.Helper'], function (CopyrightDateHelper) {
	'use strict';

	return {
		mountToApp: function mountToApp(application) {

      var footerView = 'Footer.View';
      var footerSimplifiedView = 'Footer.Simplified.View'

      // first check if one or both footer modules are loaded
      var isFooterViewLoaded = CopyrightDateHelper.isModuleLoaded(footerView);
      var isFooterViewSimplifiedLoaded = CopyrightDateHelper.isModuleLoaded(footerSimplifiedView);

      if (isFooterViewLoaded || isFooterViewSimplifiedLoaded) {

        // next check if layout module loaded
        var layout = application.getComponent('Layout');

        if (layout) {

          var thisYear = CopyrightDateHelper.getFullYear();

          isFooterViewLoaded && layout.addToViewContextDefinition(footerView, 'thisYear', 'string', function(context) {
            return thisYear
          });

          isFooterViewSimplifiedLoaded && layout.addToViewContextDefinition(footerSimplifiedView, 'thisYear', 'string', function(context) {
            return thisYear
          });
        }
      }
		},
	};
});
